import { Injectable } from '@angular/core';
import { BaseRepository } from './base.repository';

@Injectable({
  providedIn: 'root'
})

export class DealsRepository extends BaseRepository {

    getDealsHotels(code: string) {
        const url = this.baseUrl + `deals?dealName=${code}`;
        return this.get<any>(url);
    }
}